export default {
  QUEUE: 'queue',
  INREVIEW: 'in-review',
  APPROVED: 'approved',
  COMPLETED: 'completed',
}
